import React, { Fragment } from 'react'


const SingleProduct = ({ product, productID, setProductID, setProductData }) => {




    const handleClassName = (ProductStatus) => {


        if (ProductStatus === "ACTIVE") return "text-green-600 bg-green-100";
        if (ProductStatus === "SYSTEM_CANCELLED") return "text-red-600 bg-red-100";
        if (ProductStatus === "SUSPENDED") return "text-orange-600 bg-orange-100";
        if (ProductStatus === "INACTIVE") return "text-purple-600 bg-purple-100";
        if (ProductStatus === "PAUSED") return "text-orange-600 bg-orange-100";

    }




    return (
        <Fragment>
            <div className="grid grid-cols-[0.7fr_5fr_1fr]   gap-[1vmax] items-center  p-[0.8vmax_0.5vmax] rounded-xl hover:bg-gray-100 cursor-pointer"
                onClick={() => {
                    setProductID(prev => prev === product?.id ? null : product?.id)
                    setProductData(prev => prev?.id === product?.id ? {} : product)
                }}
            >
                <div className="aspect-square rounded-full grid place-items-center overflow-hidden bg-gray-200">
                    <img src={product?.custom_image} alt="" />
                </div>
                <div className="">
                    <h3 className='text-[1vmax] font-bold flex items-center' >
                        Product ID : {product?.id}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <span className={`text-[0.7vmax] font-[500] text-gray-500  inline-block  p-[0.3vmax_0.5vmax] rounded-full
                            ${handleClassName(product?.status)}`} >
                                {product?.status?.replaceAll("_", " ").toUpperCase()}
                            </span>
                    </h3>
                    <p className='text-[0.8vmax] mt-[0.1vmax] text-gray-500' >Product ID : {product?.id}</p>
                </div>
                <div className={`text-right ${productID === product?.id ? "opacity-100" : "opacity-0"} pr-[1vmax]`} >
                    <i className="fa-solid fa-check text-blue-500"></i>
                </div>
            </div>

        </Fragment>
    )
}

export default SingleProduct
